export const PREF_FAVACC_ASSET_FOR_EXPENSE = "ae";
export const PREF_FAVACC_ASSET_FOR_INCOME = "ai";
export const PREF_FAVACC_ASSET_FOR_FROM = "af";
export const PREF_FAVACC_ASSET_FOR_TO = "at";
export const PREF_FAVACC_CATEGORY_FOR_EXPENSE = "ce";
export const PREF_FAVACC_CATEGORY_FOR_INCOME = "ci";
